import { render, staticRenderFns } from "./RadioTopic.vue?vue&type=template&id=2db85e78&scoped=true&"
import script from "./RadioTopic.vue?vue&type=script&lang=js&"
export * from "./RadioTopic.vue?vue&type=script&lang=js&"
import style0 from "./RadioTopic.vue?vue&type=style&index=0&id=2db85e78&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2db85e78",
  null
  
)

export default component.exports